import { render, staticRenderFns } from "./OptComm.vue?vue&type=template&id=2d797501&"
import script from "./OptComm.vue?vue&type=script&lang=js&"
export * from "./OptComm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports